import { EditableContentBlock, EmptyPageFiller, InnerContentWrapper, MarkDownSection, PageColumn, ProfileLinks } from '@paddl/storybook';
import t from 'prop-types';
import React from 'react';
import { ProfileCharts } from './ProfileCharts';
export const SummaryTabPanel = _ref => {
  let {
    profile,
    activitiesCount
  } = _ref;
  const {
    aboutMe,
    links,
    fullName,
    profileId
  } = profile;
  return /*#__PURE__*/React.createElement(InnerContentWrapper, null, !aboutMe && links.length === 0 && /*#__PURE__*/React.createElement(EmptyPageFiller, {
    "data-test-id": "no-summary-links",
    icon: "graphStars",
    firstLine: "This profile doesn't appear to have any public content.",
    secondLine: "They must be keeping their up-skilling secret!"
  }), /*#__PURE__*/React.createElement(PageColumn, null, aboutMe && /*#__PURE__*/React.createElement(EditableContentBlock, {
    isEditable: false,
    title: "Add your About me",
    subtitle: "Share a short bio to tell more of your story.",
    heading: "About ".concat(fullName.split(' ')[0]),
    isEmptyViewAllowed: false,
    content: /*#__PURE__*/React.createElement(MarkDownSection, {
      markDown: aboutMe
    })
  }), links.length > 0 && /*#__PURE__*/React.createElement(EditableContentBlock, {
    isEditable: false,
    title: "Add Links",
    subtitle: "Share links to your website, portfolio or other profile.",
    heading: "Links",
    content: /*#__PURE__*/React.createElement(ProfileLinks, {
      links: links
    })
  }), activitiesCount >= 5 && /*#__PURE__*/React.createElement(ProfileCharts, {
    profileId: profileId
  })));
};
SummaryTabPanel.propTypes = {
  profile: t.shape({
    profileId: t.number,
    fullName: t.string,
    aboutMe: t.string,
    links: t.arrayOf(t.string)
  }).isRequired,
  activitiesCount: t.number.isRequired
};